const SELECTORS = {
	root: ".contact-experience",
	intro: ".contact-experience__intro",
	form: ".contact-experience__form",
	open: '[data-contact-form-open], a[href="#contact-form-dialog"], a[href="#contact-form"]',
	close: "[data-contact-form-close]",
};

const getBackLabel = () => {
	const lang = document.documentElement.lang.toLowerCase();

	if (lang.startsWith("ca")) return "Tornar";
	if (lang.startsWith("en")) return "Back";

	return "Volver";
};

const getThankYouMessages = (form) => {
	const component = form.querySelector("[data-contact-multistep]");
	const language = (
		component?.dataset.formLanguage ||
		document.documentElement.lang ||
		"es"
	).toLowerCase().split("-")[0];

	const messages = {
		es: {
			title: "¡Gracias por contactar con nosotros!",
			message: "Tu mensaje se ha enviado correctamente. Nos pondremos en contacto contigo lo antes posible.",
			back: "Volver a contacto",
		},
		ca: {
			title: "Gràcies per contactar amb nosaltres!",
			message: "El teu missatge s’ha enviat correctament. Ens posarem en contacte amb tu tan aviat com sigui possible.",
			back: "Tornar a contacte",
		},
		en: {
			title: "Thank you for contacting us!",
			message: "Your message has been sent successfully. We’ll get back to you as soon as possible.",
			back: "Back to contact",
		},
	};

	return messages[language] || messages.es;
};

const contactExperience = () => {
	document.querySelectorAll(SELECTORS.root).forEach((root) => {
		const intro = root.querySelector(SELECTORS.intro);
		const form = root.querySelector(SELECTORS.form);

		if (!intro || !form) return;

		const triggers = [...intro.querySelectorAll(SELECTORS.open)];
		if (!triggers.length) return;

		const panelId = form.id || `contact-form-panel-${Math.random().toString(36).slice(2, 9)}`;
		form.id = panelId;
		intro.setAttribute("aria-hidden", "false");
		form.setAttribute("aria-hidden", "true");
		form.inert = true;

		triggers.forEach((trigger) => {
			trigger.setAttribute("aria-controls", panelId);
			trigger.setAttribute("aria-expanded", "false");
		});

		let returnFocus = triggers[0];
		let closeButton = form.querySelector(SELECTORS.close);

		if (!closeButton) {
			closeButton = document.createElement("button");
			closeButton.type = "button";
			closeButton.className = "contact-experience__back";
			closeButton.dataset.contactFormClose = "";
			closeButton.textContent = getBackLabel();
			form.prepend(closeButton);
		}
		const cf7 = form.querySelector(".wpcf7");
		let thankYou;

		if (cf7) {
			const messages = getThankYouMessages(form);

			thankYou = document.createElement("section");
			thankYou.className = "contact-experience__thanks";
			thankYou.hidden = true;

			const title = document.createElement("h2");
			title.className = "contact-form-tab__title";
			title.tabIndex = -1;
			title.textContent = messages.title;

			const message = document.createElement("p");
			message.textContent = messages.message;

			const backButton = document.createElement("button");
			backButton.type = "button";
			backButton.className = "arrow-button arrow-button--previous";
			backButton.dataset.contactFormClose = "";
			backButton.textContent = messages.back;

			thankYou.append(title, message, backButton);
			cf7.after(thankYou);

			cf7.addEventListener("wpcf7mailsent", () => {
				thankYou.hidden = false;

				title.focus({ preventScroll: true });
				cf7.hidden = true;
				closeButton.hidden = true;

				setExperienceHeight(root, form);

				requestAnimationFrame(() => {
					root.scrollIntoView({
						behavior: prefersReducedMotion() ? "auto" : "smooth",
						block: "start",
					});
				});
			});
		}
		const resizeObserver = new ResizeObserver(() => {
			setExperienceHeight(root, root.classList.contains("is-form-open") ? form : intro);
		});

		resizeObserver.observe(intro);
		resizeObserver.observe(form);
		setExperienceHeight(root, intro);

		const open = (trigger) => {
			returnFocus = trigger;
			root.classList.add("is-form-open");
			document.body.classList.add("has-contact-experience-open");
			intro.inert = true;
			form.inert = false;
			intro.setAttribute("aria-hidden", "true");
			form.setAttribute("aria-hidden", "false");
			triggers.forEach((item) => item.setAttribute("aria-expanded", "true"));
			setExperienceHeight(root, form);

			requestAnimationFrame(() => {
				root.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "nearest" });
			});
			window.setTimeout(() => closeButton.focus({ preventScroll: true }), prefersReducedMotion() ? 0 : 550);

			root.dispatchEvent(new CustomEvent("contactexperience:open"));
		};

		const close = () => {
			if (thankYou && !thankYou.hidden) {


				thankYou.hidden = true;

				const response = cf7.querySelector(".wpcf7-response-output");

				if (response) {
					response.textContent = "";
				}

				cf7.hidden = false;
				closeButton.hidden = false;

				form.querySelector("[data-contact-multistep]")?.dispatchEvent(
					new CustomEvent("contactformtabs:reset")
				);
			}
			root.classList.remove("is-form-open");
			document.body.classList.remove("has-contact-experience-open");
			intro.inert = false;
			form.inert = true;
			intro.setAttribute("aria-hidden", "false");
			form.setAttribute("aria-hidden", "true");
			triggers.forEach((item) => item.setAttribute("aria-expanded", "false"));
			setExperienceHeight(root, intro);

			window.setTimeout(() => returnFocus?.focus({ preventScroll: true }), prefersReducedMotion() ? 0 : 550);
			root.dispatchEvent(new CustomEvent("contactexperience:close"));
		};

		triggers.forEach((trigger) => {
			trigger.addEventListener("click", (event) => {
				event.preventDefault();
				open(trigger);
			});
		});

		form.addEventListener("click", (event) => {
			if (event.target.closest(SELECTORS.close)) close();
		});

		root.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && root.classList.contains("is-form-open")) {
				event.preventDefault();
				close();
			}
		});
	});
};

const setExperienceHeight = (root, view) => {
	root.style.setProperty("--contact-experience-height", `${view.offsetTop + view.scrollHeight}px`);
};

const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export { contactExperience };
